import LoginView from '@/views/default/LoginView.vue'
import LoggedView from '@/views/default/logged/'
import VideosView from '@/views/default/logged/VideosView.vue'
import BooksView from '@/views/default/logged/BooksView.vue'
import UsersView from '@/views/default/logged/UsersView.vue'

const routes = [
  {
    path: '*',
    redirect: {
      name: 'loggedVideos'
    }
  },
  {
    name: 'login',
    path: '/login',
    component: LoginView
  },
  {
    name: 'logged',
    path: '/logged',
    component: LoggedView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: 'loggedVideos',
        path: 'videos',
        component: VideosView,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'loggedBooks',
        path: 'books',
        component: BooksView,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'loggedUsers',
        path: 'users',
        component: UsersView,
        meta: {
          requiresAuth: true,
          isAdmin: true
        }
      }
    ]
  }
]

export default routes
